import { createContext } from 'react';

import {
  type DivisionKey,
  type FormattedGeneralLedgerAccount,
} from '~/common/types/homeownerAssociation';
import {
  type FormattedBuildingUnit,
  type SimpleBuilding,
  type SimpleBuildingRelation,
} from '~/common/types/building';
import { type components } from '~/common/types/kpc.d';
import { type Nullable } from '~/common/types';

export type SimpleHomeownerAssociationResponse =
  components['schemas']['KeypointConnect.Api.Apis.V1.DTOs.HomeownerAssociations.Responses.SimpleHomeownerAssociationResponse'];

type HomeownerAssociationContext = {
  buildings: SimpleBuilding[];
  buildingsAreLoading: boolean;
  divisionKeys: DivisionKey[];
  divisionKeysAreLoading: boolean;
  glas: FormattedGeneralLedgerAccount[];
  glasAreLoading: boolean;
  homeownerAssociation?: SimpleHomeownerAssociationResponse;
  homeownerAssociationId: Nullable<string>;
  homeownerAssociationIsLoading: boolean;
  invalidateGlas: () => void;
  navigatedFromBuildingId?: string;
  relations: SimpleBuildingRelation[];
  relationsAreLoading: boolean;
  units: FormattedBuildingUnit[];
  unitsAreLoading: boolean;
};

const HomeownerAssociationContext = createContext<HomeownerAssociationContext>({
  buildings: [],
  buildingsAreLoading: true,
  divisionKeys: [],
  divisionKeysAreLoading: true,
  glas: [],
  glasAreLoading: true,
  homeownerAssociationId: null,
  homeownerAssociationIsLoading: true,
  invalidateGlas: () => {},
  relations: [],
  relationsAreLoading: true,
  units: [],
  unitsAreLoading: true,
});

export default HomeownerAssociationContext;
